/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/EventManager',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    var isDocumentReady = false;

    /**
     * Object to store event bindings (handlers).
     */
    var bindings = {};

    /**
     * Object to store pending events (supporting many pending events per event type)
     */
    var pending = {};

    /**
     * Saves the given event and callback data in pending collection.
     * @param {} event 
     * @param {} info 
     * @returns {} 
     */
    function savePendingEvent(event, info) {
        if (!Object.hasOwnProperty.call(pending, event)) {
            pending[event] = [];
        }
        pending[event].push(info);
        Logger.info('EventManager -> Adding pending event ' + event + '. Total number of pending events for "' + event + '":' + pending[event].length);
    }

    /**
     * Notifies all registered event handlers about specific event and provides event data to each of them.
     * @param {String} event - Event type
     * @param {Object} info - Event argument
     * @returns {} 
     */
    function notify(event, info) {
        if (!isDocumentReady) {
            savePendingEvent(event, info);
            return;
        }

        if (!Object.hasOwnProperty.call(bindings, event)) {
            return; // exit because there are no events for the given type
        }

        bindings[event].forEach(function (item) {
            item(info !== undefined ? info : {});
        });
    }

    /**
     * Executes all pending events
     * @returns {} 
     */
    function executePendingEvents() {
        for (var eventType in pending) {
            if (!pending.hasOwnProperty(eventType)) {
                return;
            }
            for (var i in pending[eventType]) {
                if (!pending[eventType].hasOwnProperty(i)) {
                    return;
                }
                notify(eventType, pending[eventType][i]);
            }
        }
    }

    /**
    * Purges all pending events. 
    * @returns {} 
    */
    function purgePendingEvents() {
        for (var data in pending) {
            if (!pending.hasOwnProperty(data)) {
                continue;
            }
            delete (pending[data]);
        }
    }

    /**
     * Registers event handler for particular event type.
     * @param {String} event
     * @param {Function} listener
     * @returns {} 
     */
    function bind(event, listener) {
        if (!Object.hasOwnProperty.call(bindings, event)) {
            bindings[event] = [];
        }

        var index = bindings[event].push(listener) - 1;
        return {
            remove: function () {
                bindings[event].splice(index, 1);
            }
        };
    }

    // Execute all pending events when the DOM is ready
    $(document).ready(function () {
        isDocumentReady = true;
        executePendingEvents();
        purgePendingEvents();
    });

    var EventManager = {
        bind: bind,
        notify: notify
    };

    Logger.debug('EventManager.js Loaded:', EventManager);

    return EventManager;
});

